import { defineMessages } from 'react-intl';

export default defineMessages({
    lossCause : {
        id: "policychange.ho.views.ho-risk-analysis.Loss Cause",
        defaultMessage: "Loss Cause"
    },
    additionalInterestDetailsCount: {
        id: 'policychange.ho.ba-risk-analysis.Claim:',
        defaultMessage: 'Claim : { count }'
    },    
});
